/* eslint-disable no-unused-vars */
import { ChangeEvent, ReactElement } from 'react';
import { Row, Col } from 'react-bootstrap';
import { Pesquisa } from '../../@types/exports';

interface Props {
  pesquisa: (x: Pesquisa) => void;
  componentRight?: ReactElement;
  placeholderSearch?: string;
  todos?: any;
  searchTag?: any;
  show?: any;
}

const Search = ({
  pesquisa, componentRight, placeholderSearch, todos, searchTag, show,
}: Props) => (
  <Row>
    <Col md={2} sm={12}>
      <div className="dataTables_length" id="dataTable_length">
        <label htmlFor="show-total">
          {show}
          <select
            name="dataTable_length"
            className="custom-select custom-select-sm form-control form-control-sm"
            id="show-total"
            aria-controls="dataTable"
            onChange={(e: ChangeEvent<HTMLSelectElement>) => (
              pesquisa({ quantidade: Number(e.target.value) })
            )}
          >
            <option>{todos}</option>
            <option value={1}>1</option>
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
        </label>
      </div>
    </Col>
    <Col md={8} sm={12}>
      <div id="dataTable_filter" className="dataTables_filter">
        <label htmlFor="search">
          {searchTag}
          <input
            type="search"
            className="form-control form-control-sm"
            id="search"
            placeholder={placeholderSearch}
            onInput={(e: ChangeEvent<HTMLInputElement>) => (
              pesquisa({ filtro: e.target.value })
            )}
            aria-controls="dataTable"
          />
        </label>
      </div>
    </Col>
    {componentRight && (
      <Col md={2} sm={12} className="d-flex justify-content-end align-items-center">
        {componentRight}
      </Col>
    )}
  </Row>
);

Search.defaultProps = {
  componentRight: undefined,
  placeholderSearch: undefined,
  todos: 'Todos',
  searchTag: 'Search',
  show: 'Show',
};

export default Search;
